import { css } from "@emotion/react";
const styles = css`
  .mdx-h1 {
  }
  .mdx-h2 {
    font-size: 18px;
    margin-top: 8px;
  }
  .mdx-h3 {
    font-size: 16px;
    margin-top: 5px;
  }
  .mdx-h4 {
    font-size: 14px;
    margin-top: 4px;
  }

  .mdx-table {
    border: solid 1px #545454;
    border-collapse: collapse;
    margin-top: 10px;
    margin-bottom: 15px;
  }
  .mdx-thead {
    background-color: #eee;
  }
  .mdx-td {
    border: solid 1px #545454;
    padding: 10px;
  }

  .mdx-ul {
  }
  .mdx-li {
    list-style-type: disc;
    margin-left: 15px;
  }
  .mdx-p {
    margin-bottom: 5px;
  }
  .mdx-a {
    text-decoration: underline;
    color: #0072ca;
  }
`;

export default styles;
